import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import Collapse from '@mui/material/Collapse'
import TableRow from '@mui/material/TableRow'
import ResponsiveTable from '@app/components/ResponsiveTable'
import ResponsiveVoucherRow from '@app/components/ResponsiveVoucherRow'
import OrderChatView from '@app/components/OrderChatView'
import { getSubVouchers } from '@app/utils/voucherUtils'
import { useCurrentUser } from '@app/context/CurrentUser'

const VouchersBundle = ({
  headers,
  cols = 8,
  open = false,
  voucher = {},
  fullWidth = false,
  subVouchers: providedSubVouchers = null,
}) => {
  const [subVouchers, setSubVouchers] = useState(providedSubVouchers || [])
  const { authData } = useCurrentUser()

  useEffect(() => {
    // If subVouchers are provided, use them directly
    if (providedSubVouchers) {
      setSubVouchers(providedSubVouchers)
      return
    }

    // Otherwise fetch them only if needed
    const fetchSubVouchers = async () => {
      if (!open) {
        return
      }

      if (voucher?.bundle && voucher?.subVouchers?.length) {
        setSubVouchers(voucher.subVouchers)
      } else if (voucher?.bundle) {
        const subVouchersData = await getSubVouchers(
          voucher,
          authData.roles.includes('PROVIDER'),
          authData.organizationId,
        )
        setSubVouchers(subVouchersData)
      }
    }
    fetchSubVouchers()
  }, [voucher, open, providedSubVouchers, authData])

  // The table content - extracted to be reused in both rendering modes
  const tableContent = (
    <ResponsiveTable
      headerColor='#f6eeff'
      headers={headers}
      sx={{ width: '100%', tableLayout: 'fixed' }}
    >
      {subVouchers.map((subVoucher) => (
        <ResponsiveVoucherRow
          backgroundColor='#faf5ff'
          key={subVoucher.id}
          headers={headers}
          voucher={{ ...subVoucher, parentUid: voucher.id }}
        />
      ))}
      <TableRow style={{ backgroundColor: '#faf5ff' }}>
        <TableCell style={{ padding: '16px' }} colSpan={headers.length}>
          <Box display='flex' justifyContent='center' alignItems='center'>
            <OrderChatView
              order={voucher}
              chatID={voucher?.id || voucher?.uid}
              color='#652d92'
              variant='bundle'
            />
          </Box>
        </TableCell>
      </TableRow>
    </ResponsiveTable>
  )

  // If fullWidth is true, render a direct container without the TableRow wrapper
  if (fullWidth) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        {!!(open && subVouchers.length) && tableContent}
      </Box>
    )
  }

  // Original rendering for use in other contexts
  return (
    <TableRow style={{ border: 0, padding: 0 }}>
      <TableCell colSpan={cols} style={{ padding: 0 }}>
        <Collapse
          style={{ width: '100%' }}
          in={!!(open && subVouchers.length)}
          timeout='auto'
          unmountOnExit
        >
          <Box mb={2}>{tableContent}</Box>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}

export default VouchersBundle
